import { LastStepVM, ParentVM, SectionVM } from 'civil-status/view-models/step-form';

export const withInterprete = (values?: LastStepVM | Array<LastStepVM>): boolean => {
  if (!values) {
    return false;
  }

  if (Array.isArray(values)) {
    return Boolean(
      values.find(
        (item) =>
          (item as SectionVM)?.isWithInterprete || (item as ParentVM)?.generality?.isWithInterprete
      )
    );
  }

  // Ottiene le chiavi dei valori del values
  const keysForm = Object.keys(values || {});

  // Trova la chiave del campo che richiede la gestione dell'interprete
  const keyObjectWithManagementInterprete = keysForm.find(
    (itemKey) =>
      (values[itemKey] as SectionVM)?.isWithInterprete ||
      (values[itemKey] as ParentVM)?.generality?.isWithInterprete
  );

  return Boolean(keyObjectWithManagementInterprete);
};
